// extracted by mini-css-extract-plugin
module.exports = {"group":"SelfDelivery_group__3osR3","workTime":"SelfDelivery_workTime__Et2Kf"};